import { useTranslation } from 'react-i18next'
import { connect, useDataItem } from 'scrivito'

import { FollowUpsTab } from './FollowUpsTab/FollowUpsTab'
import { DocumentTab } from '../SharedTabs/DocumentTab/DocumentTab'
import { MessageTab } from '../SharedTabs/MessageTab/MessageTab'
import { NavTabs, NavTabItem } from '@/Atomic/Templates/NavTabs'
import { NavTab } from '@/Atomic/Widgets/DataItemTabs/const'
import { Activity } from '@/Data/Activity/ActivityDataClass'
import { ActivityDocumentRelation } from '@/Data/ActivityDocumentRelation/ActivityDocumentRelationDataClass'
import { DataClassName } from '@/Data/const'
import { Message } from '@/Data/Message/MessageDataClass'
import { useFeatureFlagAccess } from '@/utils/featureFlagConfig'

const ALL_NAV_TABS: NavTab[] = [
  NavTab.MESSAGE,
  NavTab.FOLLOW_UPS,
  NavTab.DOCUMENT,
]

export const ActivityDataItemTabs: React.FC = connect(() => {
  const { t } = useTranslation()
  const { filterTabs } = useFeatureFlagAccess()
  const dataItem = useDataItem()
  const dataItemId = dataItem?.id() ?? ''

  if (!dataItemId) return

  const visibleNavTabs = filterTabs(ALL_NAV_TABS)
  const isVisible = (tab: NavTab) => visibleNavTabs.includes(tab)

  const messageCount = isVisible(NavTab.MESSAGE)
    ? (Message.all()
        .transform({ filters: { subjectId: dataItemId } })
        .count() ?? 0)
    : 0

  const followUpsCount = isVisible(NavTab.FOLLOW_UPS)
    ? (Activity.all()
        .transform({ filters: { origin: dataItemId } })
        .count() ?? 0)
    : 0

  const documentCount = isVisible(NavTab.DOCUMENT)
    ? (ActivityDocumentRelation.all()
        .transform({ filters: { activity: dataItemId } })
        .count() ?? 0)
    : 0

  const tabsByNavTab: Array<{ navTab: NavTab; tab: NavTabItem }> = [
    {
      navTab: NavTab.MESSAGE,
      tab: {
        id: 'messages',
        title: t('components.message.title'),
        icon: 'note',
        count: messageCount,
        content: <MessageTab />,
      },
    },
    {
      navTab: NavTab.FOLLOW_UPS,
      tab: {
        id: 'follow-ups',
        title: t('pages.activity.followUpsTitle'),
        icon: 'activity-follow-up',
        count: followUpsCount,
        content: <FollowUpsTab searchInputName="search activity-followups" />,
      },
    },
    {
      navTab: NavTab.DOCUMENT,
      tab: {
        id: 'documents',
        title: t('components.document.documents'),
        icon: 'file-empty',
        count: documentCount,
        content: (
          <DocumentTab relationTo={DataClassName.ACTIVITY_DOCUMENT_RELATION} />
        ),
      },
    },
  ]

  const tabs: NavTabItem[] = tabsByNavTab
    .filter((entry) => isVisible(entry.navTab))
    .map((entry) => entry.tab)

  if (!tabs.length) return

  return <NavTabs tabs={tabs} />
})
